import React, { useState } from "react";
import style from "./MyTask.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import useLanguageChange from "../../../hooks/useLanguageChange";

type Props = {
  workflow_actions: workflowActions;
  locale: string;
};

type workflowActions = {
  actionable_title: string;
  display_assigned_time: string;
  operation_path: string;
  title: string;
  icon_path: string;
}[];

export const MyTask = ({ workflow_actions, locale }: Props) => {
  const { t } = useLanguageChange(locale);
  const [workflowActions, setWorkflowActions] = useState<workflowActions>(workflow_actions);

  return (
    <div>
      {!workflowActions.length ? (
        <h3 className="mt-3">{t("MyTask.指定された期間に依頼された未完了のタスクはありません")}🎉</h3>
      ) : (
        <div className="d-flex flex-column" style={{ gap: "8px" }}>
          {workflowActions.map((action, index) => (
            <a href={action.operation_path} key={`mytask-${index}`} className={style.workflowAction}>
              <div className="operation-list">
                <div>
                  <img src={getImageUrl(action.icon_path)} width={40} height={40} />
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <div className="card-text yoom-text-black">{action.title}</div>
                  <div className="operation-list__title">{action.actionable_title}</div>
                  <div className="card-text yoom-text-gray-darker">{action.display_assigned_time}</div>
                </div>
                <div className="ml-auto">
                  <img src={getImageUrl("images/icons/nextGray.svg")} alt="chevron-right" width={27} height={27} />
                </div>
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
